import React from "react";

function IconMyRecentSales() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
      <path d="M4.395 13.074c.003.559.462.9 1.21.9.77 0 1.23-.363 1.23-.972 0-.457-.253-.717-.802-.813l-.385-.066c-.27-.047-.384-.125-.384-.26 0-.156.14-.254.355-.254.22 0 .395.13.4.3h.758c-.006-.542-.48-.909-1.175-.909-.706 0-1.16.371-1.16.945 0 .455.28.752.798.842l.373.066c.303.055.408.118.408.249 0 .158-.154.261-.386.261-.266 0-.446-.113-.455-.289h-.785ZM8.645 11c-.862 0-1.42.566-1.42 1.486 0 .924.554 1.489 1.42 1.489.86 0 1.418-.565 1.418-1.489 0-.92-.557-1.486-1.418-1.486Zm0 .676c.34 0 .574.316.574.81 0 .496-.235.813-.574.813-.342 0-.577-.317-.577-.813 0-.494.235-.81.577-.81ZM12.549 13.22H11.4v-2.142h-.828v2.819h1.977v-.676ZM13.06 11.078v2.819h1.25c.852 0 1.315-.508 1.315-1.446 0-.88-.473-1.373-1.315-1.373h-1.25Zm.829.656h.26c.398 0 .632.258.632.733 0 .52-.219.773-.633.773h-.26v-1.506Z" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.53 1.22a.75.75 0 0 0-1.06 0L4.69 6H2a.75.75 0 0 0-.75.75v11c0 .414.336.75.75.75h16a.75.75 0 0 0 .75-.75v-11A.75.75 0 0 0 18 6h-2.69l-4.78-4.78ZM13.19 6 10 2.81 6.81 6h6.38ZM2.75 17V7.5h14.5V17H2.75Z"
      />
    </svg>
  );
}

export default IconMyRecentSales;
